import React from 'react';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import fbLaunchedIcon from 'shared/images/facebook/fb-launched-icon.svg';

import styles from './styles';

interface Props {
  showTooltip?: boolean;
  showHoverBox?: boolean;
}
const FacebookLaunchedIcon: React.FC<Props> = ({ showTooltip = false }) => {
  return (
    <Tooltip content="Meta ad launched" disabled={!showTooltip}>
      <Flex css={styles} className="fb-launched-icon">
        <img src={fbLaunchedIcon} className="fb-launched-icon__icon" />
      </Flex>
    </Tooltip>
  );
};

export default FacebookLaunchedIcon;
